module.exports = __webpack_public_path__ + "assets/img/vdv.0a07226e.png";